import { render, staticRenderFns } from "./DlgDataConfirm.vue?vue&type=template&id=6852d83e&"
import script from "./DlgDataConfirm.vue?vue&type=script&lang=js&"
export * from "./DlgDataConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DlgDataConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
